import type { TableSettings, UserSettings, UserTables } from '../user/index';

export type UsersMeSettingsPatchRequestBody = UserSettings & {
  diagrams?: {
    tableSetup?: {
      nodes?: { _any?: never };
    };
  };
  /** null: reset settings for given table */
  tables?: Record<string, TableSettings | null>;
};

export type UsersMeSettingsResponseBody = UserSettings & {
  tables?: UserTables;
};
